(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mural-render-service"] && !Shopify.designMode) return;
  try {
    
  (function () {
  /** Texto visible traducible (window.tmI18n); si falta, vale el español. */
  function tr(key, fallback, vars) {
    const t = (window.tmI18n && window.tmI18n[key]) || fallback;
    return vars ? t.replace(/\{\{(\w+)\}\}/g, (_, n) => (vars[n] !== undefined ? vars[n] : '')) : t;
  }
  

    const MAX_EDGE = 1600;
    const QUALITY = 0.82;
    // Limites sobre el fichero ORIGINAL, antes de comprimir. El limite duro
    // existe sobre todo por el caso en que reducir() no pueda comprimir de
    // verdad (un formato que el navegador no decodifica, como el HEIC de
    // iPhone) y devuelva el original sin tocar: sin este tope, ese original
    // pesado seria exactamente lo que mas tarda en procesar FormSubmit.
    const LIMITE_DURO = 8 * 1024 * 1024;
    const LIMITE_AVISO = 3 * 1024 * 1024;

    function reducir(file) {
      return new Promise((resolve) => {
        if (!file || !file.type || file.type.indexOf('image/') !== 0) {
          resolve(file);
          return;
        }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          let width = img.width;
          let height = img.height;
          const edge = Math.max(width, height);
          if (edge > MAX_EDGE) {
            const k = MAX_EDGE / edge;
            width = Math.round(width * k);
            height = Math.round(height * k);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(img, 0, 0, width, height);
          canvas.toBlob(
            function (blob) {
              if (!blob) {
                resolve(file);
                return;
              }
              const nombre = (file.name || 'imagen').replace(/\.[^.]+$/, '') + '.jpg';
              resolve(new File([blob], nombre, { type: 'image/jpeg', lastModified: Date.now() }));
            },
            'image/jpeg',
            QUALITY
          );
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          resolve(file);
        };
        img.src = url;
      });
    }

    function ponEnInput(input, file) {
      try {
        const dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        return true;
      } catch (e) {
        return false;
      }
    }

    document.querySelectorAll('.render-svc').forEach(function (root) {
      const dialog = root.querySelector('[data-render-dialog]');
      const form = root.querySelector('[data-render-form]');
      const status = root.querySelector('[data-render-status]');
      const submit = root.querySelector('[data-render-submit]');
      const frameWrap = root.querySelector('[data-render-frame-wrap]');
      const sink = form.querySelector('iframe[name="mural-render-frame"]');
      if (!dialog || !form) return;

      let enviando = false;
      let esperandoRespuesta = false;
      let avisosLargos = [];

      function pararAvisosLargos() {
        avisosLargos.forEach(clearTimeout);
        avisosLargos = [];
      }

      // Una miniatura cuadrada por cada input de fichero. Cada [data-render-
      // preview] es hermano directo del input dentro de .render-svc__file-row,
      // asi que basta con mirar el elemento siguiente para encontrar la suya.
      const previews = [];
      root.querySelectorAll('[data-render-file]').forEach(function (input) {
        const wrap = input.parentElement;
        const preview = wrap ? wrap.querySelector('[data-render-preview]') : null;
        const img = preview ? preview.querySelector('img') : null;
        if (!preview || !img) return;
        previews.push(preview);

        function limpiar() {
          if (preview.dataset.url) {
            URL.revokeObjectURL(preview.dataset.url);
            delete preview.dataset.url;
          }
          preview.hidden = true;
          img.removeAttribute('src');
        }

        const campo = input.closest('.render-svc__field');
        const aviso = campo ? campo.querySelector('[data-render-warn]') : null;
        function ocultarAviso() {
          if (aviso) { aviso.hidden = true; aviso.textContent = ''; }
        }

        input.addEventListener('change', function () {
          const f = input.files && input.files[0];
          if (preview.dataset.url) URL.revokeObjectURL(preview.dataset.url);

          if (!f || !f.type || f.type.indexOf('image/') !== 0) {
            limpiar();
            ocultarAviso();
            return;
          }

          if (f.size > LIMITE_DURO) {
            input.value = '';
            limpiar();
            if (aviso) {
              aviso.hidden = false;
              aviso.textContent = tr('rs_too_big', 'Ese archivo pesa {{mb}} MB, demasiado para enviarlo rápido. Elige una foto más ligera (máx. 8 MB).', { mb: (f.size / 1024 / 1024).toFixed(1) });
            }
            return;
          }

          if (f.size > LIMITE_AVISO) {
            if (aviso) {
              aviso.hidden = false;
              aviso.textContent = tr('rs_big', 'Archivo de {{mb}} MB: tardará algo más en enviarse.', { mb: (f.size / 1024 / 1024).toFixed(1) });
            }
          } else {
            ocultarAviso();
          }

          const url = URL.createObjectURL(f);
          preview.dataset.url = url;
          img.src = url;
          preview.hidden = false;
        });

        input.__limpiarPreview = limpiar;
      });

      function abrir() {
        if (dialog.open) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      root.querySelectorAll('[data-render-open]').forEach(function (btn) {
        btn.addEventListener('click', abrir);
      });

      /* Enlace del menu "Diseña tu mural": /#disena-tu-mural abre el formulario. */
      function abrirPorEnlace() {
        if (location.hash === '#disena-tu-mural') abrir();
      }
      abrirPorEnlace();
      window.addEventListener('hashchange', abrirPorEnlace);

      root.querySelectorAll('[data-render-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dialog.close();
        });
      });

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      form.addEventListener('submit', function (e) {
        if (enviando) return;
        e.preventDefault();
        pararAvisosLargos();

        enviando = true;
        if (submit) {
          submit.setAttribute('aria-busy', 'true');
          submit.textContent = 'Enviando…';
        }
        if (status) {
          status.hidden = false;
          status.removeAttribute('data-state');
          status.textContent = tr('rs_sending', 'Enviando tus imágenes… no cierres esta ventana todavía.');
        }
        if (frameWrap) frameWrap.hidden = false;

        const inputs = Array.prototype.slice.call(form.querySelectorAll('[data-render-file]'));
        const trabajos = inputs.map(function (input) {
          const f = input.files && input.files[0];
          if (!f) return Promise.resolve();
          return reducir(f).then(function (chico) {
            if (chico && chico !== f) ponEnInput(input, chico);
          });
        });

        Promise.all(trabajos).then(function () {
          esperandoRespuesta = true;
          HTMLFormElement.prototype.submit.call(form);

          // FormSubmit, probado en aislamiento, tardo 37 segundos en
          // responder a un envio con una sola imagen de 300 KB. Sin avisar
          // de esto, esos segundos con el boton diciendo solo "Enviando..."
          // se leen como un formulario colgado. El aviso no cancela la
          // espera: si la respuesta llega despues, se cuenta igual como
          // envio correcto -- y ademas ahora se VE cargar en el recuadro.
          avisosLargos.push(setTimeout(function () {
            if (!esperandoRespuesta || !status) return;
            status.textContent = tr('rs_slow', 'Sigue enviándose… con imágenes puede tardar hasta un minuto. Mira el recuadro de abajo.');
          }, 8000));
          avisosLargos.push(setTimeout(function () {
            if (!esperandoRespuesta) return;
            esperandoRespuesta = false;
            enviando = false;
            if (submit) {
              submit.removeAttribute('aria-busy');
              submit.textContent = 'Enviar';
            }
            if (status) {
              status.setAttribute('data-state', 'error');
              status.textContent = tr('rs_unconfirmed', 'No hemos podido confirmar el envío. Revisa el recuadro de abajo, o escríbenos a info@tailormurals.com con las fotos.');
            }
          }, 90000));
        });
      });

      if (sink) {
        sink.addEventListener('load', function () {
          if (!esperandoRespuesta) return;
          pararAvisosLargos();
          esperandoRespuesta = false;
          enviando = false;
          if (submit) {
            submit.removeAttribute('aria-busy');
            submit.textContent = 'Enviar';
          }
          if (status) {
            status.hidden = false;
            status.setAttribute('data-state', 'ok');
            status.textContent = tr('rs_done', '¡Recibido! Te escribimos a tu correo en 24-48 h laborables con la simulación.');
          }
          form.reset();
          previews.forEach(function (preview) {
            if (preview.dataset.url) URL.revokeObjectURL(preview.dataset.url);
            delete preview.dataset.url;
            preview.hidden = true;
            const img = preview.querySelector('img');
            if (img) img.removeAttribute('src');
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
